export default __webpack_public_path__ + "static/fonts/CamphorPro-Heavy.37586fe.woff";